module.exports = __webpack_public_path__ + "img/stick_activites_rando_equestre.82e844e5.svg";